/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `created` - created
 * * `reviewed` - reviewed
 * * `unreviewed` - unreviewed
 * * `edited` - edited
 * @export
 */
export const ActionEnum = {
  created: 'created',
  reviewed: 'reviewed',
  unreviewed: 'unreviewed',
  edited: 'edited',
} as const;
export type ActionEnum = (typeof ActionEnum)[keyof typeof ActionEnum];

export function instanceOfActionEnum(value: any): boolean {
  for (const key in ActionEnum) {
    if (Object.prototype.hasOwnProperty.call(ActionEnum, key)) {
      if ((ActionEnum as Record<string, ActionEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ActionEnumFromJSON(json: any): ActionEnum {
  return ActionEnumFromJSONTyped(json, false);
}

export function ActionEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): ActionEnum {
  return json as ActionEnum;
}

export function ActionEnumToJSON(value?: ActionEnum | null): any {
  return value as any;
}
